export default __webpack_public_path__ + "static/media/mediaId242_0001.47d4f3dc.png";